"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addNewClipToClips;

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var INITIAL_REDUCE_STATE = {
  clips: [],
  clipInserted: false,
  moveClipSeconds: 0
};

function mergeState(state, changes) {
  return _objectSpread(_objectSpread({}, state), changes);
}

function addNewClipToClips(draggedClip, destinationClips) {
  var _destinationClips$red = destinationClips.reduce(function (reduceState, clip, index) {
    var clips = reduceState.clips,
        clipInserted = reduceState.clipInserted,
        moveClipSeconds = reduceState.moveClipSeconds;

    if (clipInserted) {
      return mergeState(reduceState, {
        clips: [].concat(_toConsumableArray(clips), [_objectSpread(_objectSpread({}, clip), {}, {
          startTime: clip.startTime + moveClipSeconds
        })])
      });
    }

    var a1 = draggedClip.startTime;
    var a2 = draggedClip.startTime + draggedClip.duration;
    var b1 = clip.startTime;
    var b2 = clip.startTime + clip.duration;
    var clipOverlaps = Math.max(a2, b2) - Math.min(a1, b1) < a2 - a1 + (b2 - b1);
    var nextClip = destinationClips[index + 1];
    var isLastClip = !nextClip;
    var draggedClipStartsAfter = draggedClip.startTime > clip.startTime;
    var draggedClipStartsBefore = draggedClip.startTime < clip.startTime;

    if (!clipOverlaps && draggedClipStartsAfter) {
      return mergeState(reduceState, {
        clips: isLastClip ? [].concat(_toConsumableArray(clips), [clip, draggedClip]) : [].concat(_toConsumableArray(clips), [clip]),
        clipInserted: isLastClip
      });
    }

    if (!clipOverlaps && draggedClipStartsBefore) {
      return mergeState(reduceState, {
        clips: [].concat(_toConsumableArray(clips), [draggedClip, clip]),
        clipInserted: true
      });
    }

    if (!draggedClipStartsAfter) {
      var newMoveSeconds = draggedClip.duration - (clip.startTime - draggedClip.startTime);
      return mergeState(reduceState, {
        clips: [].concat(_toConsumableArray(clips), [_objectSpread(_objectSpread({}, draggedClip), {}, {
          startTime: draggedClip.startTime
        }), _objectSpread(_objectSpread({}, clip), {}, {
          startTime: clip.startTime + newMoveSeconds
        })]),
        clipInserted: true,
        moveClipSeconds: newMoveSeconds
      });
    }

    var clipMiddleTime = clip.startTime + clip.duration / 2;
    var shouldInsertBefore = draggedClip.startTime <= clipMiddleTime;

    if (shouldInsertBefore) {
      return mergeState(reduceState, {
        clips: [].concat(_toConsumableArray(clips), [_objectSpread(_objectSpread({}, draggedClip), {}, {
          startTime: clip.startTime
        }), _objectSpread(_objectSpread({}, clip), {}, {
          startTime: clip.startTime + draggedClip.duration
        })]),
        clipInserted: true,
        moveClipSeconds: draggedClip.duration
      });
    }

    var draggedClipStartTime = clip.startTime + clip.duration;
    var draggedClipEndTime = draggedClipStartTime + draggedClip.duration;
    var newMoveClipSeconds = nextClip && nextClip.startTime < draggedClipEndTime ? Math.abs(nextClip.startTime - draggedClipEndTime) : 0;
    return mergeState(reduceState, {
      clips: [].concat(_toConsumableArray(clips), [clip, _objectSpread(_objectSpread({}, draggedClip), {}, {
        startTime: draggedClipStartTime
      })]),
      clipInserted: true,
      moveClipSeconds: newMoveClipSeconds
    });
  }, INITIAL_REDUCE_STATE),
      newClips = _destinationClips$red.clips;

  return newClips;
}